const isAddressZero = (address: string) => {
  return (
    '0000000000000000000000000000000000000000000000000000000000000000' ==
    address
  );
};

const base64ToHex = (base64Value: string) => {
  const buff = Buffer.from(base64Value, 'base64');

  return buff.toString('hex');
};

const toHex = (str: string): string => {
  let hex = '';
  for (let i = 0, l = str.length; i < l; i++) {
    hex += str.charCodeAt(i).toString(16);
  }
  return hex;
};

export { base64ToHex, isAddressZero, toHex };
